module.exports = __webpack_public_path__ + "img/56bebd2.jpg";